var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":_vm.effect,"content":_vm.content,"placement":_vm.placement}},[_c('sino-button',{staticClass:"tooltip-button",attrs:{"icon":_vm.icon,"type":"text"},on:{"click":_vm.btnClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }